// extracted by mini-css-extract-plugin
export default {"menuBlock":"YD-z","title":"ZD-z","nav":"_D-z","flexCell":"aE-z","facetLink":"bE-z"};